export class Pageable{
  private _page: number;
  private _size: number;

  constructor(page: number, size: number) {
    this._page = page;
    this._size = size;
  }

  get page(): number {
    return this._page;
  }

  set page(value: number) {
    this._page = value;
  }

  get size(): number {
    return this._size;
  }

  set size(value: number) {
    this._size = value;
  }
}
